var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5256 10.7336C14.8676 10.7336 15.9596 11.7636 15.9596 13.0296C15.9596 14.2944 14.8688 15.324 13.528 15.3268V15.3316H12.5608C10.2912 15.3316 8.15643 14.4784 6.55003 12.9292C4.93723 11.3756 4.04883 9.30201 4.04883 7.09561C4.04883 5.82961 5.14083 4.80001 6.48283 4.80001C7.82483 4.80001 8.91683 5.82801 8.91683 7.09401C8.91683 8.36001 7.82483 9.39001 6.48283 9.39001C6.08861 9.39066 5.69966 9.29944 5.34683 9.12361C5.70382 10.2977 6.35737 11.36 7.24443 12.208C8.39981 13.3207 9.87907 14.0373 11.4684 14.254C11.2233 13.8927 11.0921 13.4662 11.0916 13.0296C11.0916 11.7636 12.1836 10.7336 13.5256 10.7336ZM7.91683 7.09561C7.91683 6.38121 7.27363 5.80001 6.48283 5.80001C5.69203 5.80001 5.04883 6.38121 5.04883 7.09561C5.04883 7.81001 5.69203 8.39161 6.48283 8.39161C7.27363 8.39161 7.91683 7.81001 7.91683 7.09561ZM12.0912 13.0296C12.0912 13.744 12.7344 14.3252 13.5252 14.3252C14.316 14.3252 14.9596 13.7444 14.9596 13.0296C14.9596 12.3148 14.316 11.7336 13.5252 11.7336C12.7344 11.7336 12.0912 12.3152 12.0912 13.0296Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContact);
export default __webpack_public_path__ + "static/media/icon-contact.e2a6163945bd60a9f1fa9769f459d153.svg";
export { ForwardRef as ReactComponent };